var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-layout"},[_vm._v(" excel 预览 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }